<template>
  <div id="printBagNumber" ref="printBagNumber" class="fontSizeStyle">
    <div
      ref="printBagNumberContent"
      class="printBagNumberContent"
      style="page-break-before: always; break-inside: avoid"
    >
      <div style="display: flex; align-items: center">
        <img :src="require('@/assets/ajlogo1.svg')" alt="tu" style="width: 100px">
        <div
          style="
            font-size: 20px;
            text-align: center;
            flex: 1;
            font-weight: bold;
            margin-left: -100px;
          "
        >
          {{ $t('scripting.returnCodeList') }}
        </div>
      </div>
      <div style="margin: 10px 0">
        {{ $t('seller.licensePlateNumber') }}: {{ paramData[0].vehicleNumber }}
      </div>
      <table style="width: 100%; border-collapse: collapse; text-align: center">
        <thead>
          <tr style="background-color: #add88d">
            <th>{{ $t('GlobalSetObj.serial') }}</th>
            <th>{{ $t('navbar.siteName') }}</th>
            <th>{{ $t('scripting.returnCode') }}</th>
            <th>{{ $t('scripting.expiryTime') }}</th>
            <th>{{ $t('collectionCenter.Barcode') }}</th>
          </tr>
        </thead>
        <tbody style="text-align: center">
          <tr v-for="(item, index) in paramData">
            <td>{{ index + 1 || '--' }}</td>
            <td>{{ item.nextSiteIdName || '--' }}</td>
            <td>{{ item.returnCode || '--' }}</td>
            <td>{{ item.abortTime || '--' }}</td>
            <td>
              <svg :id="item.returnCode" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import printXq from 'print-js';
import JsBarcode from 'jsbarcode';

export default {
  props: {
    paramData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      qrData: ''
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.print01();
    },
    print01() {
      const _this = this;
      console.log(this.paramData, 'this.paramData');
      _this.$nextTick(() => {
        const generateBarcodeAll = [];
        this.paramData.forEach((item) => {
          generateBarcodeAll.push(this.generateBarcode(item.returnCode, item.returnCode));
        });
        console.log(generateBarcodeAll, 'generateBarcodeAll');
        Promise.all(generateBarcodeAll).then(() => {
          printXq({
            showModal: true,
            modalMessage: 'loading...',
            printable: 'printBagNumber', // // 文档来源：pdf或图像的url，html元素的id或json数据的对象
            type: 'html', // 可打印的类型。可用的打印选项包括：pdf，html，图像，json和raw-html。
            targetStyles: ['*'], // 库在打印HTML元素时处理任何样式
            font_size: ''
          });
          _this.$emit('hiddenBagNumberHtml');
        });
      });
    },
    generateBarcode(code) {
      return new Promise((resolve) => {
        this.$nextTick(() => {
          JsBarcode('#' + code, code, {
            height: 60,
            displayValue: false, // 是否在条形码下方显示文字
            valid: () => {
              resolve(null);
            }
          });
        });
      });
    }
  }
};
</script>
<style scoped>
.fontSizeStyle * {
  font-size: 16px;
  box-sizing: border-box;
}

table {
  border: 1px solid black;
  border-collapse: collapse;
}

th,
td {
  border: 1px solid black;
  padding: 5px;
  border-collapse: collapse;
}

#printBagNumber {
  page-break-before: always;
  break-inside: avoid; /* 避免元素内容在列间断开 */
}
</style>
